import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import CommentIcon from '@atlaskit/icon/core/comment';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.comment-field.label.non-final',
		defaultMessage: 'Comment field icon',
		description:
			'Accessible label for the icon representing the comment field in a Jira work item action card.',
	},
});

export function CommentFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<CommentIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
